import { AuthenticatedLayout } from "../../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { ExportData } from "../../../../components/AddOns/Accounting/ExportData";

export const ExportDataPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Export Data"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      mainContents={<ExportData />}
    />
  );
};
